import React, { Component } from "react";
import { getEnv } from "../../../../env";
import "./style.css";
import GoogleMap from "../../../../03-components/GoogleMap";
import { Translate } from "react-localize-redux/es/Translate";
import ProductPanel from "../../../../03-components/ProductPanel/index";
import { withLocalize } from "react-localize-redux";

class ProductsPage extends Component {
    render() {
        return (
            <div className="container-home-contact flex-grow-1">
                <ProductPanel
                    className="margin-left-15px margin-right-15px"
                    title={this.props.translate("contact")}
                >
                    <div className="contact-content">
                        <div className="map-address">
                            <div className="map">
                                <GoogleMap
                                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${getEnv(
                                        "GG_MAP_KEY",
                                    )}&v=3.exp&libraries=geometry,drawing,places`}
                                    loadingElement={
                                        <div style={{ height: `100%` }} />
                                    }
                                    containerElement={
                                        <div style={{ height: `100%` }} />
                                    }
                                    mapElement={
                                        <div style={{ height: `100%` }} />
                                    }
                                    defaultZoom={17}
                                    defaultCenter={{
                                        lat: 16.030853,
                                        lng: 108.225414,
                                    }}
                                    position={{
                                        lat: 16.030853,
                                        lng: 108.225414,
                                    }}
                                />
                            </div>
                            <div className="address">
                                <div className="company">
                                    <div className="head">
                                        <Translate id="contents.company_name" />
                                    </div>
                                    <div className={"field"}>
                                        <Translate id="contents.company_address1" />
                                    </div>
                                    <div className={"field"}>
                                        <Translate id="contents.company_address3" />
                                    </div>
                                    <div className={"field"}>
                                        <Translate id="contents.company_phone" />{" "}
                                        -{" "}
                                        <Translate id="contents.company_fax" />
                                    </div>
                                    <div className={"field"}>
                                        Email:&nbsp;
                                        <a
                                            style={{ color: "#007bff" }}
                                            href="mailto:info@baotinhoanggia.com"
                                        >
                                            info@baotinhoanggia.com
                                        </a>
                                        &nbsp;/&nbsp;
                                        <a
                                            style={{ color: "#007bff" }}
                                            href="mailto:baotinhoanggia@gmail.com"
                                        >
                                            baotinhoanggia@gmail.com
                                        </a>
                                    </div>
                                    <div className={"field"}>
                                        <Translate id={"website"} />:{" "}
                                        <a
                                            style={{ color: "#007bff" }}
                                            target={"_blank"}
                                            href={this.props.translate(
                                                "contents.company_website",
                                            )}
                                        >
                                            <Translate id="contents.company_website" />
                                        </a>
                                    </div>
                                </div>
                                <div className="bank">
                                    <div className="head">
                                        <Translate id="contents.company_bank_info" />
                                    </div>
                                    <div className={"field"}>
                                        <Translate id="contents.vcb_bank" />
                                    </div>
                                    <div className={"field"}>
                                        <Translate id="contents.vcb_bank_address" />
                                    </div>
                                    <div className={"field"}>
                                        Swift: BFTVVNVX004
                                    </div>
                                    <div className={"field"}>
                                        <Translate id="account_number" />: 0041
                                        000 156 571
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="thankyou">
                            <Translate id="contents.contact-thankyou" />
                        </div>
                    </div>
                </ProductPanel>
            </div>
        );
    }
}

export default withLocalize(ProductsPage);



// WEBPACK FOOTER //
// ./src/04-containers/_pages/Home/Contact/index.js